
export default {
  methods: {
    downloadBlob (response) {
      const blobData = response.request.response
      const fileName = this.blobFileName(response.headers['content-disposition'])
      const blobType = response.headers['content-type']

      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blobData, fileName)
      } else {
        const url = URL.createObjectURL(new Blob([blobData], {type: blobType}))
        const linkEl = document.createElement('a')
        linkEl.href = url

        linkEl.setAttribute('download', fileName)
        document.body.appendChild(linkEl)
        linkEl.click()

        URL.revokeObjectURL(url)
        linkEl.parentNode.removeChild(linkEl)
      }
    },
    blobFileName (contentDisposition) {
      return contentDisposition.split('filename="')[1].split('";')[0]
    }
  }
}
